import React from "react";
import ErrorPage from "../screens/home/ErrorPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error(error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage type="500" showNav={false} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
